import * as React from 'react'
import { bundleIcon, FluentIconsProps, wrapIcon } from '@fluentui/react-icons'

export const TimerAddRegular = wrapIcon((props: FluentIconsProps) => {
    return (
        <svg width="1em" height="1em" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M7.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm7.66 1.93a.5.5 0 1 0-.71.7l1.41 1.42a.5.5 0 1 0 .71-.7l-1.41-1.42ZM9.5 6a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.4Zm0 12a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0-1a6 6 0 1 1 0-12 6 6 0 0 1 0 12Z"
                fill="currentColor"
            />
            <path
                d="M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z"
                fill="currentColor"
            />
        </svg>
    )
}, 'TimerAddRegular')

export const TimerAddFilled = wrapIcon((props: FluentIconsProps) => {
    return (
        <svg width="1em" height="1em" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M7 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm7.45 1.43c.2-.2.51-.2.7 0l1.42 1.41a.5.5 0 1 1-.7.71l-1.42-1.41a.5.5 0 0 1 0-.71ZM16.5 11a7 7 0 1 1-14 0 7 7 0 0 1 14 0ZM9 6.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0Z"
                fill="currentColor"
            />
            <path
                d="M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z"
                fill="currentColor"
            />
        </svg>
    )
}, 'TimerAddFilled')

export const TimerAddIcon = bundleIcon(TimerAddFilled, TimerAddRegular)
